import formatsIndex from './index'
export default (id) => {
  return formatsIndex.find(function (format) {
    return format.id === id
  })
}
